import {
  HStack,
  Stack,
  Text,
  IconButton,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Box,
  Flex,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { observer } from "mobx-react-lite";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef } from "react";
import { useStores } from "../store/store_context";
import { NAV_LINKS } from "../route_titles";
import { logoutSession } from "../auth/auth";

const Header = observer(() => {
  const navigate = useNavigate();
  const { pageStore } = useStores();
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isLogoutOpen,
    onOpen: onLogoutOpen,
    onClose: onLogoutClose,
  } = useDisclosure();
  const cancelRef = useRef();

  const links = NAV_LINKS;

  const handleRoute = async (e, path) => {
    if (path === "/") {
      onLogoutOpen();
      return;
    }

    pageStore.updateSelectedPage(path);
    onClose();

    if (e.ctrlKey || e.metaKey) {
      window.open(path, "_blank");
      return;
    }
    navigate(path);
  };

  const handleLogoutConfirm = async () => {
    onLogoutClose();
    onClose();
    await logoutSession();
    navigate("/", { replace: true });
  };

  const isLogout = (path) => path === "/";

  return (
    <Box bg={"#1e1e1e"} w={"100%"} overflow="hidden">
      <AlertDialog
        isOpen={isLogoutOpen}
        leastDestructiveRef={cancelRef}
        onClose={onLogoutClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent bg="#1e1e1e" color="white" border="1px solid #333">
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Выход из аккаунта
            </AlertDialogHeader>
            <AlertDialogBody>
              Вы уверены, что хотите выйти?
            </AlertDialogBody>
            <AlertDialogFooter gap={3}>
              <Button ref={cancelRef} variant="ghost" color="white" _hover={{ bg: "whiteAlpha.200" }} onClick={onLogoutClose}>
                Отмена
              </Button>
              <Button colorScheme="red" onClick={handleLogoutConfirm}>
                Выйти
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* --- ДЕКСТОПНАЯ ВЕРСИЯ --- */}
      <Flex
        display={{ base: "none", xl: "flex" }} // Переключаемся на бургер на 1280px (xl)
        w={"100%"}
        alignItems={"stretch"} // Растягиваем элементы по высоте хедера
        padding={"0 10px"}
      >
        {links.map((item) => (
          <Box
            key={item.path}
            cursor={"pointer"}
            // ГЛАВНЫЙ СЕКРЕТ ТУТ:
            flex={"1"}               // Заставляет элементы делить ширину поровну
            textAlign={"center"}
            display="flex"
            alignItems="center"
            justifyContent="center"
            minW="0"                 // Позволяет элементу сжиматься меньше, чем его контент
            padding={"15px 5px"}     // Вертикальный отступ побольше, горизонтальный минимальный
            color={
              isLogout(item.path)
                ? "#ef4444"
                : item.path === location.pathname ? "#3b82f6" : "white"
            }
            borderBottom={
              isLogout(item.path)
                ? "2px solid transparent"
                : item.path === location.pathname ? "2px solid #3b82f6" : "2px solid transparent"
            }
            _hover={{
              color: isLogout(item.path) ? "#ff6b6b" : "#3b82f6",
              bg: isLogout(item.path) ? "red.900" : "whiteAlpha.100",
            }}
            transition={"0.2s"}
            onClick={(e) => handleRoute(e, item.path)}
          >
            <Text
              fontSize={{ xl: "12px", "2xl": "14px" }} // На 2xl и выше шрифт крупнее
              fontWeight={"700"}
              overflow="hidden"      // Защита от вылета
              textOverflow="ellipsis" // Если совсем мало места — будет "..."
            >
              {item.label}
            </Text>
          </Box>
        ))}
      </Flex>

      {/* --- МОБИЛЬНАЯ ВЕРСИЯ (БУРГЕР) --- */}
      <Flex
        display={{ base: "flex", xl: "none" }}
        padding={"10px 20px"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Text color="white" fontWeight="bold">Навигация</Text>
        <IconButton
          aria-label="Open Menu"
          icon={<HamburgerIcon color="white" />}
          variant="ghost"
          onClick={onOpen}
        />
      </Flex>

      {/* Drawer для мобилок */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg={"#1e1e1e"} color="white">
          <DrawerCloseButton />
          <DrawerHeader>Меню</DrawerHeader>
          <DrawerBody p={0}>
            {links.map((item) => (
              <Box
                key={item.path}
                p={4}
                onClick={(e) => handleRoute(e, item.path)}
                bg={item.path === location.pathname ? "whiteAlpha.200" : "transparent"}
                color={isLogout(item.path) ? "#ef4444" : "white"}
                _hover={{ bg: isLogout(item.path) ? "red.900" : "whiteAlpha.200" }}
                cursor="pointer"
                transition="0.2s"
              >
                <Text fontWeight="bold">{item.label}</Text>
              </Box>
            ))}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
});


export default Header;
